import { render } from "./Loading.vue?vue&type=template&id=5bf1bf30&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=5bf1bf30&scoped=true&lang=css"

import exportComponent from "/var/apps/front/releases/202610291844_919663d2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf1bf30"]])

export default __exports__